import { CASH_PAYMENT_ID, OTHER_ID } from '../../constants';

export function combineErrors(formik, fields, { showAllErrors } = {}) {
  return fields.reduce((errors, field) => {
    const touched = formik.touched[field];
    const fieldErrors = touched && formik.errors && formik.errors[field];
    if (fieldErrors) {
      errors.push(...(showAllErrors ? fieldErrors : fieldErrors.slice(0, 1)));
    }
    return errors;
  }, []);
}

export function isPatientCoverageInfoRequired(provider, insuranceIssuer) {
  if (!provider || !provider.upfrontInsuranceCollectionEnabled) {
    return false;
  }
  return (
    insuranceIssuer && insuranceIssuer.id !== CASH_PAYMENT_ID && insuranceIssuer.id !== OTHER_ID
  );
}
